// src/data/gameConfig.ts — Fase 5: progresión + economía + misiones
export const GAME_CONFIG = {
  title: 'AETHERIA',
  subtitle: 'Un mundo por descubrir',
  version: '0.5.0 — Fase 5',
  author: 'Aetheria Studio',
  saveVersion: 5,
  storageKey: 'aetheria:save:v5',
  optionsKey: 'aetheria:options:v1',
  defaultRegion: 'aurora_borealis' as const,
  defaultZone: 'villa_aurelia' as const,
  tileSize: 32,
  maxTeamSize: 6,
  maxBoxSize: 30,
  languages: ['es'] as const,
} as const;

export type RegionId = typeof GAME_CONFIG.defaultRegion | 'pradera_cenital' | 'abismo_zarco';

export type ZoneId =
  | 'villa_aurelia'
  | 'casa_jugador'
  | 'tienda_aurelia'
  | 'centro_aurelia'
  | 'casa_npc'
  | 'ruta_aurelia';

export const ZONE_LABELS: Record<ZoneId, string> = {
  villa_aurelia: 'Villa Aurelia',
  casa_jugador: 'Casa del Explorador',
  tienda_aurelia: 'Bazar de Liora',
  centro_aurelia: 'Centro de Descanso',
  casa_npc: 'Casa del Investigador',
  ruta_aurelia: 'Ruta Aurelia',
};

export const REGIONS: Record<RegionId, { label: string; description: string }> = {
  aurora_borealis: { label: 'Aurora Boreal', description: 'Archipiélagos flotantes bajo auroras perpetuas.' },
  pradera_cenital: { label: 'Pradera Cenital', description: 'Llanuras doradas donde danzan las Asterias de viento.' },
  abismo_zarco: { label: 'Abismo Zarco', description: 'Profundidades cristalinas aún sin cartografiar.' },
};

export const TIME_CONFIG = {
  dayLengthSeconds: 600,
  phases: ['amanecer', 'dia', 'atardecer', 'noche'] as const,
} as const;

export const ENCOUNTER_CONFIG = {
  tallgrassStepsAvg: 14,
  tallgrassCooldownSteps: 6,
  visibleRespawnSeconds: 45,
  visibleMax: 4,
  shinyChance: 0.01,
} as const;

export const COMBAT_CONFIG = {
  maxLevel: 50,
  baseXpToLevel: 20,
  xpGrowth: 1.35,
  energyPerLevel: 2,
  critChance: 0.08,
  critMultiplier: 1.6,
} as const;

export const TRAINER_CONFIG = {
  baseXpToLevel: 30,
  xpGrowth: 1.45,
  maxLevel: 50,
} as const;
